<script>
import api from '@/command/api'
import DetailFormGroup from '../../../components/DetailFormGroup'
import TableSelectModel from '../../../components/TableSelectModel'
import { balanceCouponTypeConfig, productTypeList } from '@/utils/textFile'
import { getAction, postAction, delAction } from '@/command/netTool'
import apiTool from '@/command/apiTool'
import DrawerForm from '@/components/DrawerForm'
import { Message, Modal, Button, Table } from 'ant-design-vue'
import moment from 'moment'
export default {
  data() {
    return {
      ...api.command.getState(),
      // 店铺搜索
      storeData: [],
      specialData: [],
      detail: {
        amount: null,
        provinceCode: 330000,
        provinceName: '浙江省',
        cityCode: 330200,
        cityName: '宁波市',
        shopBalanceList: [],
        usedType: [],
        mealCardFlag: '0',
      },
      regionCode: [],
      balanceCompanyList: [],
      productTypeList: [],
      mealCardTypeList: [],
      visibleBalanceCompany: false,
      showTableSelectModel: false,
    }
  },
  mounted() {
    const { id } = this.$route.query
    // 获取级联数据
    api.command.getRegionType.call(this, {
      url: '/api/region/list/330200',
      key: 'regionCode',
    })
    getAction('/api/farmBalance/queryOrderFormTypeList').then((res) => {
      if (res.code == 200) {
        this.productTypeList = res.data.map((e) => {
          return {
            name: e.desc,
            value: e.code,
          }
        })

        if (this.productTypeList.length > 1) {
          this.productTypeList.unshift({
            name: '全场',
            value: '0',
            type: 'all',
          })
        }
        if (this.productTypeList.length == 1) {
          this.detail.usedType = [this.productTypeList[0].value]
        }
      }
    })
    getAction('/api/farmBalance/getMealCardTypeList').then((res) => {
      if (res.code == 200) {
        this.mealCardTypeList = res.data.map((e) => {
          return {
            name: e.name,
            value: e.code,
          }
        })
      }
    })
    this.getBalanceCompany()
    id &&
      api.command.getDetail
        .call(this, {
          url: `/farmBalance/detail/${id}`,
        })
        .then((result) => {
          this.detail.usedType = result.usedType ? result.usedType.split(',') : []
          this.detail.shopIds = result.shopBalanceList ? result.shopBalanceList.map((e) => e.relationId) : []

          if (result.balanceCouponType === '3') {
            this.detail.commodityName = result.shopBalanceList
              ? result.shopBalanceList.map((e) => e.relationName).join(',')
              : []
          }

          this.detail.regionCode = [result.provinceCode, result.cityCode, result.areaCode]
          this.$forceUpdate()
        })
    this.storeSearch()
    this.specialSearch()
  },
  methods: {
    async getBalanceCompany() {
      await getAction('/api/balanceCompany/list').then((res) => {
        if (res.code == 200) {
          this.balanceCompanyList = res.data.map((e) => {
            return {
              ...e,
              name: e.name,
              value: e.id,
            }
          })
          this.$forceUpdate()
        }
      })
    },
    addBalanceCompany({ formData }, title) {
      const _this = this
      apiTool.showModal({
        targetClass: 'add-balance-company',
        title: title,
        view: DrawerForm,
        width: '700px',
        viewProps: {
          formProps: {
            labelCol: { span: 3 },
            wrapperCol: { span: 21 },
          },
          form: formData,
          data: [
            {
              form: [
                {
                  name: '所属单位',
                  type: 'input',
                  key: 'name',
                  rules: [
                    {
                      required: true,
                      message: '请输入所属单位',
                    },
                  ],
                },
              ],
            },
          ],
        },
        success({ data, setHidden }) {
          if (JSON.stringify(data) === '{}') {
            Message.warning('请完成表单填写')
            return
          }

          postAction(title == '编辑' ? '/balanceCompany/edit' : '/balanceCompany/save', data).then((res) => {
            if (res.data) {
              Message.warning(res.data)
              return
            }
            Message.success(res.data || '保存成功')
            _this.getBalanceCompany()
            setHidden()
          })
        },
        foot: ({ close, submit }) => {
          return [
            {
              name: '取消',
              onClick: close,
            },
            {
              name: '保存',
              type: 'primary',
              onClick: submit,
            },
          ]
        },
      })
    },
    getColumns() {
      return [
        {
          dataIndex: 'name',
          align: 'left',
          width: '90%',
          title: '所属单位',
        },
        {
          align: 'center',
          width: '20%',
          title: '操作',
          customRender: (text, records, index) => {
            return (
              <div style="display:flex;">
                <a
                  style="margin-right:10px;"
                  onClick={() => {
                    this.addBalanceCompany({ formData: records }, '编辑')
                  }}
                >
                  编辑
                </a>
                <a
                  onClick={() => {
                    Modal.confirm({
                      title: '提示',
                      content: '确认删除该条所属单位？',
                      onOk: () => {
                        delAction(`/balanceCompany/del?id=${records.id}`).then(async (res) => {
                          console.log(res, 'res')
                          if (res.data) return Message.warning(res.data)
                          Message.success('删除成功!')
                          await this.getBalanceCompany()
                        })
                      },
                      onCancel() {},
                    })
                  }}
                >
                  删除
                </a>
              </div>
            )
          },
        },
      ]
    },
    getForm1() {
      return {
        title: '基本信息',
        type: 'cardForm',
        data: [
          {
            name: '券名',
            type: 'input',
            cols: 12,
            key: 'name',
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
          },
          {
            name: '是否关联饭卡',
            type: 'switch',
            cols: 2,
            disabled: this.detail.id,
            key: 'mealCardFlag',
            reversal: true,
          },
          {
            name: '金额',
            type: 'inputNumber',
            cols: 10,
            key: 'amount',
            display: this.detail.mealCardFlag === '0',
            rules: [
              {
                required: true,
                type: 'number',
              },
            ],
          },
          {
            type: 'select',
            cols: 10,
            key: 'mealCardType',
            typeData: this.mealCardTypeList,
            name: '饭卡类型',
            disabled: this.detail.id,
            // display: false,
            display: this.detail.mealCardFlag === '1',
            props: {
              allowClear: true,
            },
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
          },
          {
            type: 'select',
            cols: 10,
            key: 'balanceCompanyId',
            typeData: this.balanceCompanyList,
            name: '所属单位',
            disabled: this.detail.id,
            onChange: (value) => {
              const obj = this.balanceCompanyList.find((e) => e.value == value) || { name: '' }
              this.detail.balanceCompanyName = obj.name
            },
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
          },
          {
            type: 'button',
            cols: 2,
            label: '所属单位管理',
            props: {
              style: {
                marginTop: '43px',
              },
              type: 'primary',
              ghost: true,
              on: {
                click: () => {
                  this.visibleBalanceCompany = true
                },
              },
            },
          },
          {
            type: 'select',
            cols: 6,
            key: 'areaCode',
            typeData: this.regionCode,
            name: '地址（宁波市内）',
            onChange: (value) => {
              const obj = this.regionCode.find((e) => e.value == value) || { name: '' }
              this.detail.areaName = obj.name
            },
          },
          {
            type: 'row',
            cols: 6,
            children: [
              {
                name: '有效期期限',
                type: 'rangePicker',
                cols: 24,
                keys: ['useStartTime', 'useEndTime'],
              },
            ],
          },
        ].filter((e) => e.display || e.display === undefined),
      }
    },
    getForm2() {
      return {
        title: '使用对象',
        type: 'cardForm',
        gutter: 10,
        data: [
          {
            name: '券针对产品类型',
            type: 'checkBoxButton',
            key: 'usedType',
            cols: 24,
            typeData: this.productTypeList,
            rules: [
              {
                required: true,
                type: 'array',
              },
            ],
          },
        ],
      }
    },
    async storeSearch(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/api/commodity/farmMainBody/list?mainBodyName=${value}`,
      })
      this.storeData = searchResult.map((el) => {
        return {
          name: el.mainBodyName,
          value: el.id,
        }
      })
    },
    async specialSearch(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/api/farmShowSpecial/getList?name=${value}&showSpecialType=0`,
      })
      this.specialData = searchResult.map((el) => {
        return {
          name: el.showName,
          value: el.id,
        }
      })
    },
    getForm3() {
      return {
        title: '使用对象',
        type: 'cardForm',
        data: [
          {
            name: '券针对对象',
            cols: 6,
            key: 'balanceCouponType',
            type: 'select',
            typeData: balanceCouponTypeConfig(),
            onChange: () => {
              this.detail.shopBalanceList = []
              this.detail.shopIds = []
            },
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
            display: true,
          },
          {
            name: '选择店铺',
            type: 'dropDownMultiInput',
            cols: 18,
            key: 'mainBodyName',
            onInputSearch: this.storeSearch,
            typeData: this.storeData,
            valueKey: 'shopIds',
            inputProps: {
              addonBefore: <a-icon type="search" />,
            },
            display: this.detail.balanceCouponType == '1',
          },
          {
            name: '选择专题页',
            type: 'dropDownMultiInput',
            cols: 18,
            key: 'mainBodyName',
            onInputSearch: this.specialSearch,
            typeData: this.specialData,
            valueKey: 'shopIds',
            inputProps: {
              addonBefore: <a-icon type="search" />,
            },
            display: this.detail.balanceCouponType == '2',
          },
          {
            name: '选择商品',
            cols: 18,
            type: 'selectBox',
            key: 'shopBalanceList',
            selectLable: 'relationName',
            display: this.detail.balanceCouponType == '3',
            placeholder: '请选择商品',
            onClick: () => {
              this.showTableSelectModel = true
            },
          },
        ].filter((e) => e.display),
      }
    },
    getForm4() {
      return {
        title: '余额卡发放',
        type: 'cardForm',
        data: [
          {
            name: '初始数量',
            type: 'input',
            cols: 12,
            key: 'balanceNum',
            rules: [
              {
                required: true,
              },
              {
                validator: (rule, value, callback) => {
                  if (value) {
                    const r = /^[0-9]*$/
                    if (!r.test(value)) {
                      callback('格式不正确')
                      return
                    }
                    callback()
                  }
                },
              },
            ],
          },
        ],
      }
    },

    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: (data) => {
            let shopBalanceList = data.shopBalanceList

            // 店铺
            if (data.balanceCouponType == '1') {
              shopBalanceList = this.storeData
                .filter((e) => data.shopIds.includes(e.value))
                .map((e) => {
                  return {
                    relationId: e.value,
                    relationName: e.name,
                    relationType: data.balanceCouponType,
                  }
                })
            }

            // 专题页
            if (data.balanceCouponType == '2') {
              shopBalanceList = this.specialData
                .filter((e) => data.shopIds.includes(e.value))
                .map((e) => {
                  return {
                    relationId: e.value,
                    relationName: e.name,
                    relationType: data.balanceCouponType,
                  }
                })
            }

            api.command[data.id ? 'editPost' : 'create']
              .call(this, {
                url: `/farmBalance/${data.id ? 'edit' : 'save'}`,
                params: {
                  ...data,
                  amount: data.amount || 0,
                  shopIds: data.shopIds && data.shopIds.length ? data.shopIds.join(',') : '',
                  useStartTime: data.useStartTime ? moment(data.useStartTime).format('YYYY-MM-DD HH:mm:ss') : '',
                  useEndTime: data.useEndTime ? moment(data.useEndTime).format('YYYY-MM-DD HH:mm:ss') : '',
                  balanceNum: data.balanceNum || 0,
                  usedType: data.usedType.join(','),
                  shopBalanceList,
                  mealCardFlag: data.mealCardType ? '1' : '0',
                },
                isPost: false,
              })
              .then((result) => {
                this.$router.push('/marketingCenter/balance')
              })
          },
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => this.$router.push('/marketingCenter/balance'),
        },
      ]
      const right = [
        {
          name: '删除',
          popTitle: '确认删除吗?',
          isPop: true,
          type: 'danger',
          ghost: true,
          onClick: () => {
            api.command.delPut.call(this, {
              url: `/base/farmCouponRule/del?ids=${this.detail.id}`,
              isPost: false,
            })
            setTimeout(() => {
              this.$router.push('/marketingCenter/balance')
            }, 500)
          },
        },
      ]
      return {
        left,
        right: this.detail.id && right,
      }
    },
  },
  render() {
    return (
      <div>
        <DetailFormGroup
          form={this.detail}
          foot={this.getFoot()}
          data={[this.getForm1(), this.detail.balanceType == '1' && this.getForm4(), this.getForm2(), this.getForm3()]}
        />
        <Modal
          title={'所属单位管理'}
          width={'760px'}
          visible={this.visibleBalanceCompany}
          onCancel={() => {
            this.visibleBalanceCompany = false
          }}
          maskClosable={false}
          footer={false}
        >
          <Button
            type="primary"
            ghost={true}
            style={{
              width: '100px',
              marginBottom: '15px',
            }}
            onClick={() => this.addBalanceCompany({ formData: { name: null } }, '添加')}
          >
            添加
          </Button>
          <Table style={this.styles} columns={this.getColumns()} dataSource={this.balanceCompanyList}></Table>
        </Modal>
        <TableSelectModel
          show={this.showTableSelectModel}
          onCancel={() => (this.showTableSelectModel = false)}
          defaultValue={this.detail.shopBalanceList?.map((e) => ({
            ...e,
            id: e.relationId,
            nativeProductName: e.relationName,
            balanceCouponType: e.relationType,
          }))}
          onOk={(selectedRows) => {
            this.detail.shopBalanceList = selectedRows.map((e) => {
              return {
                relationId: e.id,
                relationName: e.nativeProductName,
                relationType: this.detail.balanceCouponType,
              }
            })

            this.detail.commodityName = selectedRows.map((e) => e.nativeProductName).join(',')
            this.showTableSelectModel = false
          }}
        ></TableSelectModel>
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
</style>
